module.exports = __webpack_public_path__ + "img/thumbnail_PlainsZebra_f_normal.c55a0730.png";